import { FC, useCallback } from 'react';

import { useQuery } from 'hooks/useQuery';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { pushGTMEvent } from 'utils/analyticsUtils';
import { resendVerificationEmail, signUpSelector } from 'store/signupState';
import { productRegistrationSelector } from 'store/productRegistrationState';

import VerifyAccount from 'components/fragments/VerifyAccount';
import Loader from 'components/UI/Loader';

const VerifyEmailPage: FC = () => {
  const dispatch = useAppDispatch();
  const { data, isLoading } = useAppSelector(signUpSelector);
  const { productInfo } = useAppSelector(productRegistrationSelector);

  // Params
  const [email] = useQuery('email');

  // Resend verification
  const onResendVerification = useCallback(() => {
    pushGTMEvent('resendEmailVerification');
    const { customerAccountExists, loginAccountExists } = data.accountStatus;
    const shouldResendUserVerification =
      customerAccountExists && !loginAccountExists;

    if (email) {
      dispatch(
        resendVerificationEmail(
          email,
          shouldResendUserVerification,
          productInfo?.iprId
        )
      );
    }
  }, [dispatch, productInfo, email, data]);

  if (isLoading) {
    return <Loader center padding size="large" />;
  }

  return (
    <VerifyAccount
      title="verify_email_page.title"
      description={[
        'verify_email_page.paragraph',
        'verify_email_page.paragraph2'
      ]}
      buttonText="verify_email_page.btn_resend"
      submitForm={onResendVerification}
      email={email}
    />
  );
};

export default VerifyEmailPage;
